import React, { useState } from "react";
import { Jumbotron, Container, Button, Modal } from "react-bootstrap";
import { shape } from "prop-types";
import "./gallery.scss";
import GalleryCarousel from "./gallery-carousel";

const Gallery = ({ gallery }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section id="gallery">
        <Jumbotron className="text-center">
          <Container>
            <h2>{gallery.text}</h2>
            <Button
              variant="outline-secondary"
              size="lg"
              className="mt-3"
              onClick={handleShow}
            >
              View
            </Button>
          </Container>
        </Jumbotron>
      </section>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Gallery</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GalleryCarousel photos={gallery.photos} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

Gallery.propTypes = {
  gallery: shape({}).isRequired
};

export default Gallery;
